import { useContext } from 'react';

import GenerateShortenedLinkButton from '@/components/GenerateShortenedLinkButton';
import useSchedulingLinks from '@/hooks/useSchedulingLinks';
import PersonContext from '@/pages/Person/PersonContext';
import Alert from '@/ui/components/Alert';
import DataList, { DataRow } from '@/ui/components/DataList';
import Spinner from '@/ui/components/Spinner';

const SchedulingLinksSection = () => {
  const { person } = useContext(PersonContext);

  const {
    data: schedulingLinks,
    error,
    isError,
    isPending
  } = useSchedulingLinks({
    personId: person.id,
    params: { person_id: person.id }
  });

  if (isPending) {
    return <Spinner label="Loading scheduling links..." />;
  }

  if (isError) {
    return <Alert level="error" message={error?.message} />;
  }

  return (
    <>
      {schedulingLinks?.length === 0 ? (
        <Alert level="info" message="No scheduling links found." />
      ) : (
        <DataList>
          {schedulingLinks?.map(
            (schedulingLink, index) =>
              schedulingLink && (
                <DataRow
                  key={`${schedulingLink.link_title}-${index}`}
                  label={schedulingLink.link_title}>
                  {schedulingLink.link_encoded_url && (
                    <GenerateShortenedLinkButton link={schedulingLink.link_encoded_url} />
                  )}

                  {schedulingLink.link_errors && (
                    <Alert level="error" message={schedulingLink.link_errors} />
                  )}
                </DataRow>
              )
          )}
        </DataList>
      )}
    </>
  );
};

export default SchedulingLinksSection;
